<template>
  <div :class="bem()">
    <button
      :class="bem('tab', { selected: ['sunglasses', 'prescription'].includes(props.selectedProductType) })"
      @click="handleSelectedOption('sunglasses')"
    >
      Sunglasses
    </button>
    <button
      :class="bem('tab', { selected: props.selectedProductType === 'eyeglasses' })"
      @click="handleSelectedOption('eyeglasses')"
    >
      Eyeglasses
    </button>
  </div>
</template>

<script setup lang="ts">
interface EyeglassesToggleProps {
  selectedProductType: 'sunglasses' | 'eyeglasses' | 'prescription'
}

const props = defineProps<EyeglassesToggleProps>()

const emits = defineEmits(['toggled-product-type'])

const bem = useBEM('EyeglassesToggle')

function handleSelectedOption(option) {
  if (
    option === 'sunglasses' &&
    ['eyeglasses', 'prescription'].includes(props.selectedProductType)
  ) {
    emits('toggled-product-type', 'prescription')

    return
  }

  emits('toggled-product-type', option)
}
</script>

<style lang="postcss" scoped>
.EyeglassesToggle {
  @apply flex gap-3;
}

.EyeglassesToggle__tab {
  @apply flex-grow font-bold text-sm p-1 block
    bg-white
    rounded-lg
    border border-grey-400 hover:border-grey-500;
}

.EyeglassesToggle__tab--selected,
.EyeglassesToggle__tab--selected:hover {
  @apply border-black;
}
</style>
